<!-- display-mobile-01 preview — YouTube Video Ad on Google video partners in-stream -->
<app-mobile-frame>
  <!-- START: Publisher page -->
  <div class="ytv-gpm-page">
    <!-- The partner site's own header, stubbed out: the video is the subject. -->
    <span class="ytv-gpm-topbar placeholder"></span>

    <!-- START: Video panel -->
    <div class="ytv-gpm-panel d-flex flex-column align-items-center">
      <button type="button" class="ytv-gpm-close d-flex align-items-center justify-content-center" aria-label="Close">
        <i class="bi bi-x-lg"></i>
      </button>

      <img
        class="ytv-gpm-logo"
        src="assets/images/google-campaign-logos/collection/valamar-collection-512x512-color.png"
        alt=""
      />

      <div class="ytv-gpm-headline">{{ headline }}</div>
      <div class="ytv-gpm-url">{{ displayUrl }}</div>

      <a
        [href]="data.url"
        target="_blank"
        rel="noopener noreferrer"
        class="ytv-gpm-player"
      >
        <img *ngIf="thumbnailUrl; else noCreative" class="ytv-gpm-creative" [src]="thumbnailUrl" alt="" />

        <ng-template #noCreative>
          <div class="ytv-gpm-creative creative-missing">
            <ng-container *ngIf="isResolving; else askForVideo">
              Reading video format&hellip;
            </ng-container>
            <ng-template #askForVideo>
              Add a video to see this preview
            </ng-template>
          </div>
        </ng-template>

        <!-- Player chrome, only drawn over a creative — it is unreadable on
             the grey empty slot. -->
        <ng-container *ngIf="thumbnailUrl">
          <span class="ytv-gpm-countdown">00:16</span>
          <span class="ytv-gpm-progress"></span>
        </ng-container>
      </a>

      <a
        [href]="data.url"
        target="_blank"
        rel="noopener noreferrer"
        class="ytv-gpm-cta"
        >{{ ctaText }}</a
      >
    </div>
    <!-- END: Video panel -->

    <!-- The article list the ad sits on top of; the last row clips at the frame -->
    <div class="ytv-gpm-list d-flex flex-column">
      <div *ngFor="let article of articles" class="ytv-gpm-row d-flex flex-row">
        <span class="ytv-gpm-thumb placeholder"></span>
        <div class="ytv-gpm-row-text d-flex flex-column">
          <span class="ytv-gpm-bar placeholder"></span>
          <span class="ytv-gpm-bar ytv-gpm-bar-short placeholder"></span>
        </div>
      </div>
    </div>
  </div>
  <!-- END: Publisher page -->
</app-mobile-frame>
